var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-table-column',{attrs:{"prop":_vm.prop,"align":"center","label":_vm.label,"width":_vm.width}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }